module.exports = __webpack_public_path__ + "img/request.7eb9eb7f.svg";